function getVariantPrice(product, vat_incl = false) {
    if (product.variant != null) {
        let price = null;
        if (product.variant.volume_prices != null && product.variant.volume_prices.length > 0) {
            for (let i = product.variant.volume_prices.length - 1; i >= 0; i--) {
                const volume_discount = product.variant.volume_prices[i];

                if (product.amount >= volume_discount.from) {
                    price = vat_incl ? volume_discount.price_vat_incl : volume_discount.price;
                    break;
                }
            }
        } else {
            price = vat_incl ? product.variant.price_vat_incl : product.variant.price;
        }
        return price;
    }
    return null;
}

function getAvailableVariantStock(variant) {
    let availableStock = variant.stock;
    if (variant.stock_block) {
        const stockBlock = parseInt(variant.stock_block);

        if (availableStock >= stockBlock) {
            availableStock = availableStock - stockBlock;
        } else {
            availableStock = 0;
        }
    }
    return availableStock;
}

export { getVariantPrice, getAvailableVariantStock };
